import domReady from '@wordpress/dom-ready';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

domReady(() => {
  Fancybox.bind('.photos_gallery__thumbnail[data-fancybox]', {
    Toolbar: {
      display: {
        left: ['infobar'],
        middle: [],
        right: ['slideshow', 'download', 'thumbs', 'close'],
      },
    },
  });
});
